<template>
  <div class="proposal-profile">
    <section-title
      class="my-4 proposal-profile__section-title"
      icon="fas fa-info-circle"
      reverse
      title="Información de PO"
      title-class="proposal-profile__section-title__info"
    />
    <div class="general-info bg-secondary-3 p-4 rounded">
      <div class="row">
        <div class="col">
          <span class="title">Número de PO:</span>
          <p class="content">
            {{ details.poNumber || '-' }}
          </p>
        </div>
        <div class="col">
          <span class="title">Fecha de registro:</span>
          <p class="content">
            {{ details.poDate | date('dd MMM yyyy') }}
          </p>
        </div>
        <div class="col">
          <span class="title">Balance de PO:</span>
          <p class="content">
            {{ details.poBalance | currency }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';

export default {
  name: 'ProposalPOInfo',
  components: {
    SectionTitle,
  },
  props: {
    proposalStatusId: {
      type: Number,
      default: () => 0,
    },
    details: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.proposal-profile {
  ::v-deep &__section-title {
    .title-icon {
      font-size: 14px;
      color: map-get($colors, 'orange');
    }

    .dot {
      background-color: white;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__info {
      font-size: 1rem;
      @media screen and (min-width: 768px) {
        font-size: 1.125rem;
      }
    }
  }

  .general-info {
    .title {
      font-size: 0.875rem;
      color: map-get($colors, 'gray-6');
    }
    .content {
      font-weight: bold;
      color: map-get($colors, 'black');
    }
  }

  .service-info {
    font-size: 1.125rem;
    .sub-title {
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 768px) {
    .general-info {
      .content {
        font-weight: normal;
      }
    }
    .service-info {
      font-size: 1rem;
    }
  }
}
</style>
